"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBRadio;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Global components
 * By Juan Rodrigo <jponceflores@svb.com> (www.svb.com)
 * Summary
 * This component renders a SVB radio
 */

/**
 * SVBRadio
 * @param {string} name - Value for the "name" property of the input element
 * @param {string} id - Value for the "id" property of the input element and "HTMLfor" property of the label element
 * @param {string} value - Value for the "value" property of the input element
 * @param {string} [type = "default"] - Type of the radio button
 * @param {string} [label] - Label of the radio button
 * @param {boolean} [disabled = false] - Disabled state
 * @param {boolean} [defaultChecked = false] - Default checked state
 * @param {string} [extraClasses = ""] - Extra classes to be added to the div element wrapping the button and label
 * @param {function} onChange - Function to execute when the radio button is clicked
 * @returns JSX element
 */

function SVBRadio(props) {
  // Prop error handling
  let componentError = false;
  const typeCheck = function typeCheck(prop, types) {
    let extraValidations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!types.includes(typeof prop)) componentError = true;
    if (extraValidations && typeof prop !== "undefined") {
      for (let validation of extraValidations) {
        if (!validation(prop)) componentError = true;
      }
    }
    return prop;
  };
  const id = typeCheck(props.id, ["string"]);
  const name = typeCheck(props.name, ["string"]);
  const value = typeCheck(props.value, ["string", "number"]);
  const type = typeCheck(props.type, ["string", "undefined"], [value => ["chip", "default"].includes(value)]) || "default";
  const label = typeCheck(props.label, ["string", "undefined"]);
  const disabled = typeCheck(props.disabled, ["boolean", "undefined"]) || false;
  const defaultChecked = typeCheck(props.defaultChecked, ["boolean", "undefined"]) || false;
  const onChange = typeCheck(props.onChange, ["function"]);
  const extraClasses = typeCheck(props.extraClasses, ["string", "undefined"]) || "";

  // Prop error check
  if (componentError) return /*#__PURE__*/_react.default.createElement("p", null, "Invalid prop sent, check console for prop type errors.");
  return /*#__PURE__*/_react.default.createElement("div", {
    className: extraClasses
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "radio",
    onChange: onChange,
    id: id,
    name: name,
    value: value,
    disabled: disabled,
    defaultChecked: defaultChecked
  }), label && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "radio_label ".concat(type === "chip" ? "radio_label-chip" : "")
  }, label));
}
;
SVBRadio.propTypes = {
  name: _propTypes.default.string.isRequired,
  id: _propTypes.default.string.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  type: _propTypes.default.oneOf(["chip", "default"]),
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  disabled: _propTypes.default.bool,
  defaultChecked: _propTypes.default.bool,
  onChange: _propTypes.default.func.isRequired,
  extraClasses: _propTypes.default.string
};